import CabinTypeInput from "../../../components/CabinTypeInput";
import CardTypeInput from "../../../components/CardTypeInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CurrencyInput from "../../../components/CurrencyInput";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

const CreateCurrency = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Currency",
      route: "/website/loyalty/currency",
    },
    {
      title: "Add Currency",
      route: "/website/loyalty/currency/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Currency"}>
      <CustomHeaderTitle title={"Create Currency"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Currency"}
      ></HeaderBread>
      <CurrencyInput currency={{}} />
    </Layout>
  );
};

export default CreateCurrency;
